export default __webpack_public_path__ + "static/media/sounds.e8c926c5.webm";